import { getSignKey } from "@/utils/cache";
import { MD5, enc } from "crypto-js";
import { rsaDecrypt } from "@/utils/encrypt";
import qs from "qs";
const generateRandomString = (length) => {
  let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (var i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * chars.length);
    result += chars.charAt(randomIndex);
  }
  return result;
};

const jsonToUrlParam = (json) => {
  const str = Object.keys(json)
    .map((key) => {
      if (JSON.stringify(json[key])) {
        return key + "=" + json[key];
      }
    })
    .filter((item) => item)
    .join("&");
  return str;
};

function getUrlParams(url) {
  if (!url || !url.includes("?")) return;
  // 通过 ? 分割获取后面的参数字符串
  let urlStr = url.split("?")[1];
  // 创建空对象存储参数
  let obj = {};
  // 再通过 & 将每一个参数单独分割出来
  let paramsArr = urlStr.split("&");
  let arr = "";
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过=将每一个参数分割为 key:value 的形式 let
    arr = paramsArr[i].split("=");
    obj[arr[0]] = arr[1];
  }
  return obj;
}

function removeCharacter(str, char) {
  // 创建正则表达式，使用特定字符作为分隔符
  let regex = new RegExp(`\\${char}`, "g");
  // 使用特定字符分隔字符串，得到分隔后的数组
  let parts = str.split(regex);
  // 将数组的元素拼接成新的字符串
  let result = parts.join("");

  return result;
}
//加签
export const countersign = (urlStr, method, params, isForm) => {
  let key = getSignKey();
  const decryptMsg = rsaDecrypt(key);
  const url = urlStr.includes("proxy/") ? removeCharacter(urlStr, "proxy/") : urlStr;
  // console.log("解码后的signKey===", decryptMsg);
  if (!url || !method || !decryptMsg) return;
  let str = "";
  const nowDate = parseInt(Date.now() / 1000);
  const randomString = generateRandomString(16);
  if (params) {
    str = `${method.toUpperCase()}\n${url[0] == "/" ? "/mock" + url : "/mock/" + url}${
      method == "get" ? (isNullOrEmpty(params) ? "?" + jsonToUrlParam(params) : "") : ""
    }\n${
      method == "post" && !isForm ? stringifyWithoutEscaping(params) : isForm ? jsonToUrlParam(params) : ""
    }\n${nowDate}\n${randomString}\n${decryptMsg}`;
  } else {
    str = `${method.toUpperCase()}\n${
      url[0] == "/" ? "/mock" + url : "/mock/" + url
    }\n\n${nowDate}\n${randomString}\n${decryptMsg}`;
  }
  // console.log("拼接的字符串=====", str);
  // 加密字符串
  const md5String = MD5(str);
  const encryptedString = md5String.toString(enc.Hex);
  const caseString = encryptedString.toString().toUpperCase();
  // console.log("时间戳，随机数，最后验签======", nowDate, randomString, caseString);
  // console.log("加签成功！！！！！", str);
  return {
    timestamp: nowDate,
    randomString,
    signKey: caseString,
  };
};

//验签
export const visaVerification = (timestamp, randomString, signKey, response) => {
  let key = getSignKey();
  const decryptMsg = rsaDecrypt(key);
  if (!decryptMsg || !timestamp || !randomString || !signKey || !response) return;
  const str = `${response}\n${timestamp}\n${randomString}\n${decryptMsg}`;
  // console.log("验签拼接的字符串=====", str);
  const md5String = MD5(str);
  const encryptedString = md5String.toString(enc.Hex);
  const caseString = encryptedString.toString().toUpperCase();
  if (caseString === signKey) {
    // console.log("验签通过！！！！！");
    return "pass";
  } else {
    // console.log("验签失败！！！！！", str);
    return "no_pass";
  }
};

function stringifyWithoutEscaping(obj) {
  if (!obj) return;
  return JSON.stringify(obj)
    .replace(/\"\[/g, "[")
    .replace(/\]\"/g, "]")
    .replace(/\"\{/g, "{")
    .replace(/\}\"/g, "}")
    .replace(/\\/g, "");
}

function isNullOrEmpty(parameter) {
  if (typeof parameter === "object") {
    if (Array.isArray(parameter)) {
      return parameter.length !== 0;
    } else {
      return Object.keys(parameter).length !== 0;
    }
  } else {
    return !!parameter;
  }
}
